import {
  protoOf180f3jzyo7rfj as protoOf,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  VOID7hggqo3abtya as VOID,
  emptyList1g2z5xcrvp2zy as emptyList,
  getKClass1s3j9wy1cofik as getKClass,
  Unit_instance104q5opgivhr8 as Unit_instance,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
  Enum3alwj03lh1n41 as Enum,
  to2cs3ny02qtbcb as to,
  mapOf2zpbbmyqk8xpf as mapOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_getInstance1rlvzabi952im as Companion_getInstance,
  Kind_Factory_getInstance2ge7vb99ubfwr as Kind_Factory_getInstance,
  BeanDefinitionhif1nxb54kgk as BeanDefinition,
  FactoryInstanceFactory2tq2q9e5id3pz as FactoryInstanceFactory,
  KoinDefinition2pr0kscd0vkk6 as KoinDefinition,
  module39wmcymxxg0fj as module_0,
} from './projects-core-koin-core.mjs';
import { ISessionDataProvidercfh7rhcdvasx as ISessionDataProvider } from './Shared7Punches-common-base.mjs';
import {
  IFeatureFlagEvaluatorscidb4c0cp4 as IFeatureFlagEvaluator,
  FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_getInstance1rlpby9q90frf as FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_getInstance,
} from './Shared7Punches-infrastructure-featureflag.mjs';
import { IPlanFeatureAccessor1c22ybcggkrw as IPlanFeatureAccessor } from './Shared7Punches-business-domains-billing-domain.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForInterface(ICourseAssignmentAccessor, 'ICourseAssignmentAccessor', VOID, VOID, VOID, [1]);
initMetadataForInterface(ITrainingReviewRequestAccessor, 'ITrainingReviewRequestAccessor');
initMetadataForInterface(ITrainingTaskSignOffReviewAccessor, 'ITrainingTaskSignOffReviewAccessor');
initMetadataForClass(Course, 'Course');
initMetadataForClass(CourseAssignment, 'CourseAssignment');
initMetadataForClass(CourseAssignmentStatus, 'CourseAssignmentStatus', VOID, Enum);
initMetadataForClass(TrainingReviewRequestType, 'TrainingReviewRequestType', VOID, Enum);
initMetadataForInterface(ICourseAssignmentMutator, 'ICourseAssignmentMutator', VOID, VOID, VOID, [1]);
initMetadataForInterface(IApproveTrainingTaskSignOff, 'IApproveTrainingTaskSignOff', VOID, VOID, VOID, [2]);
initMetadataForClass(ApproveTrainingTaskSignOff, 'ApproveTrainingTaskSignOff', VOID, VOID, [IApproveTrainingTaskSignOff], [2]);
initMetadataForInterface(IGetPendingTrainingReviewRequestCount, 'IGetPendingTrainingReviewRequestCount');
initMetadataForClass(GetPendingTrainingReviewRequestCount, 'GetPendingTrainingReviewRequestCount', VOID, VOID, [IGetPendingTrainingReviewRequestCount]);
initMetadataForInterface(IGetTrainingReviewRequests, 'IGetTrainingReviewRequests');
initMetadataForClass(GetTrainingReviewRequests, 'GetTrainingReviewRequests', VOID, VOID, [IGetTrainingReviewRequests]);
initMetadataForInterface(IGetTrainingTaskSignOffReview, 'IGetTrainingTaskSignOffReview');
initMetadataForClass(GetTrainingTaskSignOffReview, 'GetTrainingTaskSignOffReview', VOID, VOID, [IGetTrainingTaskSignOffReview]);
initMetadataForInterface(IIsTrainingEnabled, 'IIsTrainingEnabled');
initMetadataForClass(IsTrainingEnabled, 'IsTrainingEnabled', VOID, VOID, [IIsTrainingEnabled]);
//endregion
function ICourseAssignmentAccessor() {
}
function ITrainingReviewRequestAccessor() {
}
function ITrainingTaskSignOffReviewAccessor() {
}
function get_trainingDomainModule() {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  return trainingDomainModule;
}
var trainingDomainModule;
function trainingDomainModule$lambda($this$module) {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2 = trainingDomainModule$lambda$lambda;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind = Kind_Factory_getInstance();
  var secondaryTypes = emptyList();
  var def = new BeanDefinition(scopeQualifier, getKClass(IApproveTrainingTaskSignOff), null, tmp2, kind, secondaryTypes);
  var factory = new FactoryInstanceFactory(def);
  $this$module.p1c(factory);
  new KoinDefinition($this$module, factory);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_0 = trainingDomainModule$lambda$lambda_0;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_0 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_0 = Kind_Factory_getInstance();
  var secondaryTypes_0 = emptyList();
  var def_0 = new BeanDefinition(scopeQualifier_0, getKClass(IIsTrainingEnabled), null, tmp2_0, kind_0, secondaryTypes_0);
  var factory_0 = new FactoryInstanceFactory(def_0);
  $this$module.p1c(factory_0);
  new KoinDefinition($this$module, factory_0);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_1 = trainingDomainModule$lambda$lambda_1;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_1 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_1 = Kind_Factory_getInstance();
  var secondaryTypes_1 = emptyList();
  var def_1 = new BeanDefinition(scopeQualifier_1, getKClass(IGetTrainingReviewRequests), null, tmp2_1, kind_1, secondaryTypes_1);
  var factory_1 = new FactoryInstanceFactory(def_1);
  $this$module.p1c(factory_1);
  new KoinDefinition($this$module, factory_1);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_2 = trainingDomainModule$lambda$lambda_2;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_2 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_2 = Kind_Factory_getInstance();
  var secondaryTypes_2 = emptyList();
  var def_2 = new BeanDefinition(scopeQualifier_2, getKClass(IGetTrainingTaskSignOffReview), null, tmp2_2, kind_2, secondaryTypes_2);
  var factory_2 = new FactoryInstanceFactory(def_2);
  $this$module.p1c(factory_2);
  new KoinDefinition($this$module, factory_2);
  // Inline function 'org.koin.core.module.Module.factory' call
  var tmp2_3 = trainingDomainModule$lambda$lambda_3;
  // Inline function 'org.koin.core.module.Module.factory' call
  // Inline function 'org.koin.core.module._factoryInstanceFactory' call
  var scopeQualifier_3 = Companion_getInstance().s1a_1;
  // Inline function 'org.koin.core.definition._createDefinition' call
  var kind_3 = Kind_Factory_getInstance();
  var secondaryTypes_3 = emptyList();
  var def_3 = new BeanDefinition(scopeQualifier_3, getKClass(IGetPendingTrainingReviewRequestCount), null, tmp2_3, kind_3, secondaryTypes_3);
  var factory_3 = new FactoryInstanceFactory(def_3);
  $this$module.p1c(factory_3);
  new KoinDefinition($this$module, factory_3);
  return Unit_instance;
}
function trainingDomainModule$lambda$lambda($this$factory, it) {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(ICourseAssignmentMutator), null, null);
  return new ApproveTrainingTaskSignOff(tmp$ret$0);
}
function trainingDomainModule$lambda$lambda_0($this$factory, it) {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ISessionDataProvider), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp_0 = $this$factory.q1d(getKClass(IFeatureFlagEvaluator), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$2 = $this$factory.q1d(getKClass(IPlanFeatureAccessor), null, null);
  return new IsTrainingEnabled(tmp, tmp_0, tmp$ret$2);
}
function trainingDomainModule$lambda$lambda_1($this$factory, it) {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ITrainingReviewRequestAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(IFeatureFlagEvaluator), null, null);
  return new GetTrainingReviewRequests(tmp, tmp$ret$1);
}
function trainingDomainModule$lambda$lambda_2($this$factory, it) {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$0 = $this$factory.q1d(getKClass(ITrainingTaskSignOffReviewAccessor), null, null);
  return new GetTrainingTaskSignOffReview(tmp$ret$0);
}
function trainingDomainModule$lambda$lambda_3($this$factory, it) {
  _init_properties_TrainingDomainModule_kt__j9nlka();
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp = $this$factory.q1d(getKClass(ITrainingReviewRequestAccessor), null, null);
  // Inline function 'org.koin.core.scope.Scope.get' call
  var tmp$ret$1 = $this$factory.q1d(getKClass(IFeatureFlagEvaluator), null, null);
  return new GetPendingTrainingReviewRequestCount(tmp, tmp$ret$1);
}
var properties_initialized_TrainingDomainModule_kt_90bubw;
function _init_properties_TrainingDomainModule_kt__j9nlka() {
  if (!properties_initialized_TrainingDomainModule_kt_90bubw) {
    properties_initialized_TrainingDomainModule_kt_90bubw = true;
    trainingDomainModule = module_0(VOID, trainingDomainModule$lambda);
  }
}
function Course(id, title, description, isMandatory) {
  this.c6r_1 = id;
  this.d6r_1 = title;
  this.e6r_1 = description;
  this.f6r_1 = isMandatory;
}
protoOf(Course).toString = function () {
  return 'Course(id=' + this.c6r_1.toString() + ', title=' + this.d6r_1 + ', description=' + this.e6r_1 + ', isMandatory=' + this.f6r_1 + ')';
};
protoOf(Course).hashCode = function () {
  var result = this.c6r_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.d6r_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.e6r_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.f6r_1) | 0;
  return result;
};
protoOf(Course).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Course))
    return false;
  var tmp0_other_with_cast = other instanceof Course ? other : THROW_CCE();
  if (!this.c6r_1.equals(tmp0_other_with_cast.c6r_1))
    return false;
  if (!(this.d6r_1 === tmp0_other_with_cast.d6r_1))
    return false;
  if (!(this.e6r_1 === tmp0_other_with_cast.e6r_1))
    return false;
  if (!(this.f6r_1 === tmp0_other_with_cast.f6r_1))
    return false;
  return true;
};
function CourseAssignment(id, uuid, course, startedAt, completedAt, dueDate, stepStatuses) {
  this.g6r_1 = id;
  this.h6r_1 = uuid;
  this.i6r_1 = course;
  this.j6r_1 = startedAt;
  this.k6r_1 = completedAt;
  this.l6r_1 = dueDate;
  this.m6r_1 = stepStatuses;
}
protoOf(CourseAssignment).toString = function () {
  return 'CourseAssignment(id=' + this.g6r_1.toString() + ', uuid=' + this.h6r_1 + ', course=' + this.i6r_1.toString() + ', startedAt=' + toString(this.j6r_1) + ', completedAt=' + toString(this.k6r_1) + ', dueDate=' + toString(this.l6r_1) + ', stepStatuses=' + toString_0(this.m6r_1) + ')';
};
protoOf(CourseAssignment).hashCode = function () {
  var result = this.g6r_1.hashCode();
  result = imul(result, 31) + getStringHashCode(this.h6r_1) | 0;
  result = imul(result, 31) + this.i6r_1.hashCode() | 0;
  result = imul(result, 31) + (this.j6r_1 == null ? 0 : this.j6r_1.hashCode()) | 0;
  result = imul(result, 31) + (this.k6r_1 == null ? 0 : this.k6r_1.hashCode()) | 0;
  result = imul(result, 31) + (this.l6r_1 == null ? 0 : this.l6r_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.m6r_1) | 0;
  return result;
};
protoOf(CourseAssignment).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CourseAssignment))
    return false;
  var tmp0_other_with_cast = other instanceof CourseAssignment ? other : THROW_CCE();
  if (!this.g6r_1.equals(tmp0_other_with_cast.g6r_1))
    return false;
  if (!(this.h6r_1 === tmp0_other_with_cast.h6r_1))
    return false;
  if (!this.i6r_1.equals(tmp0_other_with_cast.i6r_1))
    return false;
  if (!equals(this.j6r_1, tmp0_other_with_cast.j6r_1))
    return false;
  if (!equals(this.k6r_1, tmp0_other_with_cast.k6r_1))
    return false;
  if (!equals(this.l6r_1, tmp0_other_with_cast.l6r_1))
    return false;
  if (!equals(this.m6r_1, tmp0_other_with_cast.m6r_1))
    return false;
  return true;
};
var CourseAssignmentStatus_NOT_STARTED_instance;
var CourseAssignmentStatus_IN_PROGRESS_instance;
var CourseAssignmentStatus_COMPLETED_instance;
var CourseAssignmentStatus_entriesInitialized;
function CourseAssignmentStatus_initEntries() {
  if (CourseAssignmentStatus_entriesInitialized)
    return Unit_instance;
  CourseAssignmentStatus_entriesInitialized = true;
  CourseAssignmentStatus_NOT_STARTED_instance = new CourseAssignmentStatus('NOT_STARTED', 0);
  CourseAssignmentStatus_IN_PROGRESS_instance = new CourseAssignmentStatus('IN_PROGRESS', 1);
  CourseAssignmentStatus_COMPLETED_instance = new CourseAssignmentStatus('COMPLETED', 2);
}
function CourseAssignmentStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function CourseAssignmentStatus_NOT_STARTED_getInstance() {
  CourseAssignmentStatus_initEntries();
  return CourseAssignmentStatus_NOT_STARTED_instance;
}
function CourseAssignmentStatus_IN_PROGRESS_getInstance() {
  CourseAssignmentStatus_initEntries();
  return CourseAssignmentStatus_IN_PROGRESS_instance;
}
function CourseAssignmentStatus_COMPLETED_getInstance() {
  CourseAssignmentStatus_initEntries();
  return CourseAssignmentStatus_COMPLETED_instance;
}
var TrainingReviewRequestType_TASK_SIGNOFF_instance;
var TrainingReviewRequestType_entriesInitialized;
function TrainingReviewRequestType_initEntries() {
  if (TrainingReviewRequestType_entriesInitialized)
    return Unit_instance;
  TrainingReviewRequestType_entriesInitialized = true;
  TrainingReviewRequestType_TASK_SIGNOFF_instance = new TrainingReviewRequestType('TASK_SIGNOFF', 0);
}
function TrainingReviewRequestType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TrainingReviewRequestType_TASK_SIGNOFF_getInstance() {
  TrainingReviewRequestType_initEntries();
  return TrainingReviewRequestType_TASK_SIGNOFF_instance;
}
function ICourseAssignmentMutator() {
}
function ApproveTrainingTaskSignOff(courseAssignmentMutator) {
  this.n6r_1 = courseAssignmentMutator;
}
function GetPendingTrainingReviewRequestCount(accessor, featureFlagEvaluator) {
  this.o6r_1 = accessor;
  this.p6r_1 = featureFlagEvaluator;
}
function GetTrainingReviewRequests(accessor, featureFlagEvaluator) {
  this.q6r_1 = accessor;
  this.r6r_1 = featureFlagEvaluator;
  this.s6r_1 = mapOf(to(TrainingReviewRequestType_TASK_SIGNOFF_getInstance(), FeatureFlag_MOBILE_TRAINING_MANAGER_TASK_SIGN_OFFS_getInstance()));
}
function GetTrainingTaskSignOffReview(accessor) {
  this.t6r_1 = accessor;
}
function IApproveTrainingTaskSignOff() {
}
function IGetPendingTrainingReviewRequestCount() {
}
function IGetTrainingReviewRequests() {
}
function IGetTrainingTaskSignOffReview() {
}
function IIsTrainingEnabled() {
}
function IsTrainingEnabled(sessionDataProvider, featureFlagEvaluator, planFeatureAccessor) {
  this.u6r_1 = sessionDataProvider;
  this.v6r_1 = featureFlagEvaluator;
  this.w6r_1 = planFeatureAccessor;
}
//region block: exports
export {
  ICourseAssignmentAccessor as ICourseAssignmentAccessor1kq9psvks8u5i,
  ITrainingReviewRequestAccessor as ITrainingReviewRequestAccessor39vjylhpgn8zg,
  ITrainingTaskSignOffReviewAccessor as ITrainingTaskSignOffReviewAccessorycsti4iwagpr,
  get_trainingDomainModule as get_trainingDomainModuleqtwusw5q7img,
  CourseAssignment as CourseAssignment1xjmha07g2pas,
  Course as Course38dfyat4grbns,
  ICourseAssignmentMutator as ICourseAssignmentMutator2azke9qzwsfw9,
  IApproveTrainingTaskSignOff as IApproveTrainingTaskSignOffmmrogffiho1m,
  IGetPendingTrainingReviewRequestCount as IGetPendingTrainingReviewRequestCountpuzoadshl3tu,
  IGetTrainingReviewRequests as IGetTrainingReviewRequests2z12zd5nec5rv,
  IGetTrainingTaskSignOffReview as IGetTrainingTaskSignOffReviewuy8iaddf3me0,
  IIsTrainingEnabled as IIsTrainingEnabled3aj37ldfvkupo,
  CourseAssignmentStatus_COMPLETED_getInstance as CourseAssignmentStatus_COMPLETED_getInstance1juqpp2aasyzo,
  CourseAssignmentStatus_IN_PROGRESS_getInstance as CourseAssignmentStatus_IN_PROGRESS_getInstancek678yld7zzw6,
  CourseAssignmentStatus_NOT_STARTED_getInstance as CourseAssignmentStatus_NOT_STARTED_getInstance35085ko59qrt3,
};
//endregion

